import { render, staticRenderFns } from "./wellcome-dashboard.vue?vue&type=template&id=6c602c80&"
import script from "./wellcome-dashboard.vue?vue&type=script&lang=js&"
export * from "./wellcome-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports